import { Component, signal } from '@angular/core';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { NzButtonModule, NzButtonSize } from 'ng-zorro-antd/button'
import { NzDropdownModule } from 'ng-zorro-antd/dropdown'
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { NzDrawerModule } from 'ng-zorro-antd/drawer';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { BridgeHireIcon } from '../../bridge-hire-icon/bridge-hire-icon';
import { NotificationBadge } from '../notification-badge/notification-badge';
import { Router, RouterModule } from '@angular/router';
import { LocalStorageService } from '../../services/local-storage-service';
import { LOCALSTORAGEKEYS } from '../../../models/enum';
import { AuthService } from '../../core/services/auth';
import { Auth } from '@angular/fire/auth'
import { signOutResponse } from '../../../models/auth.model';
import { NavigationItem } from '../../../models/navigation.model';
import { AccountType } from '../../../models/enum';
@Component({
  selector: 'app-header',
  imports: [NzLayoutModule, NzMenuModule, NzButtonModule, BridgeHireIcon, NzDropdownModule, NzAvatarModule, NotificationBadge, RouterModule, NzDrawerModule, NzIconModule],
  templateUrl: './header.html',
  styleUrl: './header.css',
})
export class Header {
  mobileMenuVisible = signal<boolean>(false);
  navigationItems = signal<NavigationItem[]>([])
  dropDownMenuItems = signal<NavigationItem[]>([])
  candiateNavigationsItems: NavigationItem[] = [
    {
      label: 'Salaries',
      routerLink: '/salaries'
    },
  ];

  subNavigationItems: NavigationItem[] = [
    {
      label: 'Roles',
      routerLink: '/roles'
    },
    {
      label: 'Companies',
      routerLink: '/companies'
    },
  ];

  referrerNavigationsItems: NavigationItem[] = [

    {
      label: 'Inbox',
      routerLink: '/my-referrals'
    },
    {
      label: 'Candidate Hub',
      routerLink: '/candidate-discovery'
    },
    {
      label: 'Companies',
      routerLink: '/companies'
    },
  ]

  candidateDropDownMenuItems: NavigationItem[] = [
    {
      label: 'Profile',
      routerLink: '/dashboard/user-profile'
    },
    {
      label: 'Resume',
      routerLink: '/resume/upload'
    },
    {
      label: 'Messages',
      routerLink: '/messages'
    },


  ]

  referrerDropDownMenuItems: NavigationItem[] = [
    {
      label: 'Profile',
      routerLink: '/dashboard/user-profile'
    },
    {
      label: 'Messages',
      routerLink: '/messages'
    },

  ]




  constructor(private router: Router,
    private authService: AuthService,
    private ls: LocalStorageService,
    private auth: Auth,
  ) {
    this.router = router;
    this.authService = authService;
    this.auth = auth;
  }

  ngOnInit(): void {
    this.setNavigationItems();
  }

  onNavigateToHome() {
    this.router.navigate(['/'])
  }

  navigateToLogin(): void {
    this.router.navigate(['/auth/login']);
  }

  isAuthenticated(): boolean {
    return this.auth.currentUser !== null;
  }

  setNavigationItems(): void {
    this.authService.userObservable.subscribe({
      next: (user) => {
        if (user?.account_type === AccountType.JobSeeker || user?.account_type === AccountType.Admin) {
          this.navigationItems.set(this.candiateNavigationsItems);
          this.dropDownMenuItems.set(this.candidateDropDownMenuItems);
        } else if (user?.account_type === AccountType.Referrer) {
          this.navigationItems.set(this.referrerNavigationsItems);
          this.dropDownMenuItems.set(this.referrerDropDownMenuItems);
        } else {
          this.navigationItems.set(this.candiateNavigationsItems);
          this.dropDownMenuItems.set(this.candidateDropDownMenuItems);
        }
      }
    })
  }

  logout(): void {
    this.authService.signOut().subscribe({
      next: (response: signOutResponse) => {
        this.auth.signOut();
        this.ls.clearItem(LOCALSTORAGEKEYS.USER);
        this.authService.currentUserSubject.next(null);
      },
      error: (err) => {
        console.error(err);
        this.auth.signOut();
        this.authService.currentUserSubject.next(null);
        this.router.navigate(['/auth/login']);
      },
      complete: () => {
        this.router.navigate(['/auth/login']);
      }
    })
  }

  openMobileMenu(): void {
    this.mobileMenuVisible.set(true);
  }

  closeMobileMenu(): void {
    this.mobileMenuVisible.set(false);
  }

}
